export default __webpack_public_path__ + "85ab5ec618b9175b9d33fa1ce555c68d.svg";